import $ from "jquery"

function initInfoPopup() {
    const $infopopup = $("#infopopup");
    $("#buttonbar .icon-info").on("click", function() {
        $infopopup.addClass("visible");
    });

    $infopopup.find(".icon-menubutton-a").on("click", function() {
        $infopopup.removeClass("visible");
    });
}

$(function() {
    if($(".tplprojektdetail").length > 0) {
        initInfoPopup();
    }
});